/**
 * NZ Great Walk cancellation registry (frontend).
 *
 * Mirrors the per-hut entityKeys registered in the backend
 * `cancellation-tracker-registry.service`. Each hut has its own Outing
 * document; a walk's aggregate view is the union of its huts.
 */

export const NZ_GREAT_WALK_CANCELLATIONS = {
  milford: {
    slug: 'milford',
    name: 'Milford Track',
    trackKey: 'milford',
    /** North → south along the track (also cancellation-scarcity order). */
    huts: [
      {
        label: 'Clinton',
        fullName: 'Clinton Hut',
        entityKey: 'nz-milford-clinton-hut',
        outingId: '6506194a60e9e6fdd8a61ffe',
      },
      {
        label: 'Mintaro',
        fullName: 'Mintaro Hut',
        entityKey: 'nz-milford-mintaro-hut',
        outingId: '6506194a60e9e6fdd8a62003',
      },
      {
        label: 'Dumpling',
        fullName: 'Dumpling Hut',
        entityKey: 'nz-milford-dumpling-hut',
        outingId: '6506194a60e9e6fdd8a62008',
      },
    ],
  },
  routeburn: {
    slug: 'routeburn',
    name: 'Routeburn Track',
    trackKey: 'routeburn',
    huts: [
      {
        label: 'Routeburn Flats',
        fullName: 'Routeburn Flats Hut',
        entityKey: 'nz-routeburn-flats-hut',
        outingId: '6506194a60e9e6fdd8a62053',
      },
      {
        label: 'Routeburn Falls',
        fullName: 'Routeburn Falls Hut',
        entityKey: 'nz-routeburn-falls-hut',
        outingId: '6506194a60e9e6fdd8a6205d',
      },
      {
        label: 'Lake Mackenzie',
        fullName: 'Lake Mackenzie Hut',
        entityKey: 'nz-routeburn-lake-mackenzie-hut',
        outingId: '6506194a60e9e6fdd8a62062',
      },
    ],
  },
  kepler: {
    slug: 'kepler',
    name: 'Kepler Track',
    trackKey: 'kepler',
    huts: [
      {
        label: 'Luxmore',
        fullName: 'Luxmore Hut',
        entityKey: 'nz-kepler-luxmore-hut',
        outingId: '6506194a60e9e6fdd8a61fa8',
      },
      {
        label: 'Iris Burn',
        fullName: 'Iris Burn Hut',
        entityKey: 'nz-kepler-iris-burn-hut',
        outingId: '6506194a60e9e6fdd8a61fad',
      },
      {
        label: 'Moturau',
        fullName: 'Moturau Hut',
        entityKey: 'nz-kepler-moturau-hut',
        outingId: '6506194a60e9e6fdd8a61fb7',
      },
    ],
  },
};

export const NZ_GREAT_WALK_CANCELLATION_LIST = Object.values(
  NZ_GREAT_WALK_CANCELLATIONS
);

/** Blog slug for a walk's cancellations page. */
export function walkCancellationsSlug(walkSlug) {
  return `${walkSlug}-track-cancellations`;
}

/** Route path for a walk's cancellations page. */
export function walkCancellationsPath(walkSlug) {
  return `/blogs/${walkCancellationsSlug(walkSlug)}`;
}

export const GREAT_WALKS_CANCELLATIONS_HUB_PATH =
  '/blogs/great-walks-cancellations';
